<template>
<m-pageframe
  title="RedChirp Home"
>
<v-container
>
     <m-select-employee-endpoint
        :selected_endpoint="null"
        v-on:select="onSelectEndpoint"
    />

</v-container>
</m-pageframe>
</template>

<script>
export default {
    methods: {
        onSelectEndpoint(item) {
            this.$rc.toHomeForEndpoint(this.$router, item.endpoint, false);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>